if (!customElements.get('pagination-theme')) {
  class Pagination extends HTMLElement {
    constructor() {
      super();
      const id = this.dataset.section;

      this.button = this.querySelector('.load-more');
      this.grid = document.querySelector('[data-id=' + id + ']');

      this.animations_enabled =
        document.body.classList.contains('animations-true') &&
        typeof gsap !== 'undefined';

      this.i = 2;

      // Restore state early
      this.savedPage = parseInt(sessionStorage.getItem('habitat_page'), 10);
      this.savedScroll = parseInt(sessionStorage.getItem('habitat_scroll'), 10);
    }

    connectedCallback() {
      const navType =
  performance.getEntriesByType('navigation')[0]?.type;

const isBackNavigation = navType === 'back_forward';

if (isBackNavigation && this.savedPage && this.savedPage > 1) {
  this.restoreState();
} else {
  // 🔥 Clear stale state on normal navigation
  sessionStorage.removeItem('habitat_page');
  sessionStorage.removeItem('habitat_scroll');
}

      if (this.classList.contains('pagination-type--loadmore')) {
        this.loadMore();
      }

      if (this.classList.contains('pagination-type--infinite')) {
        this.infinite();
      }

      this.bindProductClicks();
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }

    // Track product clicks (Habitat-safe)
    bindProductClicks() {
      this.grid.addEventListener('click', (e) => {
        const link = e.target.closest('a');

        if (link && link.href.includes('/products/')) {
          sessionStorage.setItem('habitat_scroll', window.scrollY);
          sessionStorage.setItem('habitat_page', this.i - 1);
        }
      });
    }

    addUrlParam(search, key, page) {
      const newParam = key + '=' + page;
      let params = '?' + newParam;

      if (search) {
        params = search.replace(
          new RegExp('([?&])' + key + '[^&]*'),
          '$1' + newParam
        );

        if (params === search) {
          params += '&' + newParam;
        }
      }

      return params;
    }

    loadMore() {
      this.button.addEventListener('click', () => {
        this.loadProducts();
        this.button.blur();
        return false;
      });
    }

    infinite() {
      this.observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].intersectionRatio === 1) {
            this.loadProducts();
          }
        },
        { threshold: [0, 1] }
      );

      this.observer.observe(this);
    }

    loadProducts() {
      if (this.getAttribute('loading')) return;

      const nextPage = this.i;
      const url =
        document.location.pathname +
        this.addUrlParam(document.location.search, 'page', nextPage);

      this.setAttribute('loading', true);
      this.i++;

      fetch(url)
        .then((res) => res.text())
        .then((html) => {
          this.renderProducts(html);

          // Save state AFTER successful load
          sessionStorage.setItem('habitat_page', this.i - 1);
          sessionStorage.setItem('habitat_scroll', window.scrollY);

          this.removeAttribute('loading');
        });
    }

    renderProducts(html) {
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const grid = parsed.getElementById('product-grid');

      if (!grid) {
        if (this.observer) this.observer.unobserve(this);
        if (this.button) this.button.classList.add('visually-hidden');
        return;
      }

      const products = grid.querySelectorAll('.column');

      products.forEach((el) => this.grid.appendChild(el));

      if (this.animations_enabled) {
        gsap.set(products, { opacity: 0, y: 30 });

        gsap.to(products, {
          duration: 0.5,
          y: 0,
          opacity: 1,
          stagger: 0.05,
        });
      }
    }

    // Core restore logic (Habitat optimized)
    async restoreState() {
      this.setAttribute('loading', true);

      const targetPage = this.savedPage;

      for (let p = 2; p <= targetPage; p++) {
        const url =
          document.location.pathname +
          this.addUrlParam('', 'page', p);

        await fetch(url)
          .then((res) => res.text())
          .then((html) => {
            this.renderProducts(html);
          });
      }

      this.i = targetPage + 1;

      // Restore scroll AFTER render completes
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          window.scrollTo(0, this.savedScroll || 0);
        });
      });

      this.removeAttribute('loading');
    }
  }

  customElements.define('pagination-theme', Pagination);
}